<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_v"></a><em>Dedication</em></p>
<p class="dedication1"><em>John F. X. Burton, S.J.<br/>1921–1997</em></p>
<p class="dedication1"><em>Thurston N. Davis, S.J.<br/>1913–1986</em></p>
<p class="dedication1"><em>Joseph R. Frese, S.J.<br/>1914–2002</em></p>
<p class="dedication1"><em>David S. Toolan, S.J.<br/>1935–2002</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?073aa7b2